import React from "react";
import shellStyles from "../styles/AdminShell.module.css";

export function AdminLoginGate({ code, loading, onCodeChange, onVerify }) {
  return (
    <div className={shellStyles.loginPage}>
      <div className={shellStyles.loginBox}>
        <div className={shellStyles.loginEyebrow}>Админка</div>
        <h2 className={shellStyles.loginTitle}>Введите код входа из VK</h2>
        <input
          type="text"
          value={code}
          onChange={(event) => onCodeChange(event.target.value)}
          placeholder="Код из VK"
          className={shellStyles.loginInput}
        />
        <button type="button" onClick={onVerify} disabled={loading} className={shellStyles.loginButton}>
          {loading ? "Проверяем..." : "Войти"}
        </button>
      </div>
    </div>
  );
}

export default AdminLoginGate;
